export const SET_NEXT_PAGE = "SET_NEXT_PAGE";
export const QUESTIONS_FETCH_REQUEST = "QUESTIONS_FETCH_REQUEST";
export const QUESTIONS_FETCH_SUCCESS = "QUESTIONS_FETCH_SUCCESS";
export const QUESTIONS_FETCH_FAIL = "QUESTIONS_FETCH_FAIL";
export const SET_CHECKBOX_ANSWER_CHOICE = "SET_CHECKBOX_ANSWER_CHOICE";
export const SET_RADIO_ANSWER_CHOICE = "SET_RADIO_ANSWER_CHOICE";
export const SET_TEXT_ANSWER_CHOICE = "SET_TEXT_ANSWER_CHOICE";
export const RESET_QUESTIONS = "RESET_QUESTIONS";

export function setNextPage(nextPage) {
    return { type: SET_NEXT_PAGE, payload: nextPage };
}
export function setTextAnswerChoice(textValue, questionId) {
    return {
        type: SET_TEXT_ANSWER_CHOICE, payload: {
        value: textValue,
        questionId: questionId }
    };
}

export function setcheckBoxAnswerChoice(questionId,choice,value) {
    return {
        type: SET_CHECKBOX_ANSWER_CHOICE, payload: {
        questionId: questionId,
        choice: choice,
        choiceValue: value
    } };
}

export function setRadioAnswerChoice(questionId, choice) {
    return {
        type: SET_RADIO_ANSWER_CHOICE, payload: {
            questionId: questionId,
            choice: choice,
            
        }
    };
}
export const resetQuestions = () => {
    return {
      type: RESET_QUESTIONS,
    };
};

export const fetchQuestionsRequest = () => {
    return {
        type: QUESTIONS_FETCH_REQUEST,
    };
};

export const fetchQuestionsSuccess = (quizQuestionData,totalpages) => {
    return {
        type: QUESTIONS_FETCH_SUCCESS,
        payload: {
            quizQuestionData: quizQuestionData,
            totalPages: totalpages
        },
    };
};

export const fetchQuestionsFailure = (error) => {
    return {
        type: QUESTIONS_FETCH_FAIL,
        payload: error,
    };
};